import { FaUndo } from "react-icons/fa";
import "./MarkIncompleteButton.css";
import { Tooltip } from "../Tooltip";

export function MarkIncompleteButton({ onClick, isActive }) {
  return (
      <div className="toolbar-button-wrapper">
        <button onClick={onClick} className="mark-incomplete-button">
          <FaUndo />
        </button>
        {isActive && <div className="button-underline mark-incomplete-underline" />}
      </div>
  );
}
